/* src/app/pages/auth/password/forgot/component.scss */
.error {
  font-size: 12px;
}
/*# sourceMappingURL=component.css.map */
